// Whether a task page updates live (over the relay) or by polling, beside its title.
import { Tooltip } from "rizzui";

import { useT } from "../i18n";
import { DotStatus } from "../ui/status";

export function LiveBadge({ live }: { live: boolean }) {
  const t = useT().tasks.live;
  return (
    <Tooltip content={live ? t.onHint : t.pollingHint} placement="bottom">
      <span className="inline-flex items-center text-xs font-medium text-gray-500" role="status" aria-label={live ? t.on : t.polling}>
        <DotStatus tone={live ? "green" : "gray"} label={live ? t.on : t.polling} pulse={live} />
      </span>
    </Tooltip>
  );
}
